import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

const KEY = "kha-install-dismissed";
const DAYS = 7;
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream;
const dismissedRecently = () => Date.now() - Number(localStorage.getItem(KEY) || 0) < DAYS * 864e5;
let deferred = null;
window.addEventListener("beforeinstallprompt", (e) => { e.preventDefault(); deferred = e; window.dispatchEvent(new Event("kha-installable")); });

export default function InstallBanner() {
  const [prompt, setPrompt] = useState(deferred);
  const [hidden, setHidden] = useState(() => standalone() || dismissedRecently());
  useEffect(() => {
    const on = () => setPrompt(deferred);
    const installed = () => setHidden(true);
    window.addEventListener("kha-installable", on);
    window.addEventListener("appinstalled", installed);
    return () => { window.removeEventListener("kha-installable", on); window.removeEventListener("appinstalled", installed); };
  }, []);
  const ios = isIOS();
  if (hidden || (!prompt && !ios)) return null;
  const later = () => { localStorage.setItem(KEY, String(Date.now())); setHidden(true); };
  const install = async () => { prompt.prompt(); const r = await prompt.userChoice; deferred = null; setPrompt(null); if (r.outcome === "accepted") setHidden(true); else later(); };
  return <div className="install-banner" data-testid="install-banner">
    <img src="/icon-192.png" alt="KHA" />
    <div><strong>Instal aplikasi KHA</strong><small>{ios && !prompt ? "Ketuk Bagikan lalu Tambah ke Layar Utama" : "Buka lebih cepat langsung dari layar utama."}</small></div>
    {prompt && <button className="yellow-btn small" onClick={install} data-testid="install-accept"><Download size={15} /> Instal</button>}
    <button className="outline-btn compact" onClick={later} data-testid="install-later">{prompt ? "Nanti" : <X size={15} />}</button>
  </div>;
}
